<template>
    <v-card v-if="pendingApprovals.length" class="rounded-xl">
        <v-banner elevation="15" lines="three">
            <template v-slot:prepend>
                <v-badge :content="pendingApprovals.length" color="error">
                    <v-icon
                        style="cursor: pointer"
                        @click="staffTimeOff"
                        size="x-large"
                        icon="mdi:mdi-bell-outline"
                    ></v-icon>
                </v-badge>
            </template>

            <v-banner-text>
                <h4>
                    You have {{ pendingApprovals.length }} pending "Time Off
                    Request(s)". Please approve or deny.
                </h4>
            </v-banner-text>
        </v-banner>
    </v-card>
</template>

<script>
import axios from "axios";

export default {
    data: () => ({
        alert: false,
        pendingApprovals: [],
    }),
    async mounted() {
        try {
            await axios
                .get(route("api.time-off-request.queryPendingApproval"))
                .then((res) => {
                    this.pendingApprovals = res.data;
                });
        } catch (err) {
            console.log(err);
        }
    },
    methods: {
        staffTimeOff() {
            //user/time-off
            return (window.location.href = route("user.time-off"));
        },
    },
};
</script>

<style scoped>
#blink {
    animation: blink 4s linear infinite;
}

@keyframes blink {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>
